<template>
    <div class="carousel-container" :class="{'reduced-width': !showBottomCarousel}">
        <div class="d-flex flex-column" ref="carousel-container">
            <b-container>
                <b-row v-if="media_item && media_item.slide_title_enabled">
                    {{ media_item.slide_title }}
                </b-row>
                <b-row align-h="end" class="mb-2">
                    <b-badge variant="info" v-if="media_item && media_item.teacher_only">Teacher Only</b-badge>
                </b-row>
                <b-row class="text-center">
                    <b-col cols="1">
                        <div
                            class="d-flex justify-content-center align-items-center h-100"
                        >
                            <b-btn
                                v-if="!isFirstItem"
                                content="Previous Media"
                                v-tippy
                                data-cy="previous-media"
                                class="navigation-button"
                                @click="prevWalkthroughMediaItem()"
                            >
                                <font-awesome-icon :icon="['fas', 'chevron-left']"/>
                            </b-btn>
                        </div>
                    </b-col>
                    <b-col cols="10">
                        <div v-if="media_item" class="main-carousel-div" ref="main_carousel_div">
                            <div v-if="media_item.question && media_item.question.type === 'text_block'"
                                 class="d-flex flex-column justify-center h-100 card-container">
                                <div
                                    v-html="text_block_body(media_item.question)"
                                    class="card-body d-flex flex-column justify-content-center align-items-center h-100"
                                ></div>
                            </div>
                            <div v-else-if="media_item.question && media_item.question.type === 'media_block'"
                                 class="d-flex justify-content-center align-items-center h-100 card-container">
                                <div
                                    v-if="media_item.question.content.media.type === 'image'"
                                    class="card-body mt-4 d-flex justify-content-center align-items-center h-100"
                                >
                                    <img
                                        :src="media_item.question.content.media.src"
                                        :alt="media_item.question.content.media.alt"
                                    >
                                </div>
                                <div
                                    v-else-if="media_item.question.content.media.type === 'audio'"
                                    class="card-body mt-4 d-flex justify-content-center align-items-center h-100"
                                >
                                    <audio ref="videoAudioElement" class="d-flex mb-0" controls>
                                        <source :src="media_item.question.content.media.src" type="audio/mpeg">
                                        Your browser does not support the audio element.
                                    </audio>
                                </div>
                                <div
                                    v-else-if="media_item.question.content.media.type === 'video'"
                                    class="mb-3 d-flex walkthrough-video"
                                >
                                    <video ref="videoAudioElement" width="100%" height="auto" controls>
                                        <source :src="media_item.question.content.media.src" type="video/mp4">
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                            </div>
                            <div v-else class="d-flex justify-content-center align-items-center h-100 card-container">
                                <div
                                    v-if="media_item.type === 'image'"
                                    class="card-body mt-4 d-flex justify-content-center align-items-center h-100"
                                >
                                    <img :src="media_item.url" :alt="media_item.alt">
                                </div>
                                <div
                                    v-else-if="media_item.type === 'audio'"
                                    class="card-body mt-4 d-flex flex-column justify-content-center align-items-center h-100"
                                >
                                    <b-img
                                        v-if="media_item.splash_url"
                                        :src="media_item.splash_url"
                                        class="w-75"
                                        thumbnail
                                    />
                                    <audio ref="videoAudioElement" class="d-flex mb-0" controls>
                                        <source :src="media_item.url" type="audio/mpeg">
                                        Your browser does not support the audio element.
                                    </audio>
                                </div>
                                <div v-else-if="media_item.type === 'video'" class="mb-3 d-flex walkthrough-video">
                                    <video ref="videoAudioElement" width="100%" height="auto" controls>
                                        <source :src="media_item.url" type="video/mp4">
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                                <div v-else class="h-100 w-100">
                                    <img
                                        class="h-100 w-100 pdf-preview"
                                        :src="media_item.url"
                                    />
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="1">
                        <div
                            class="d-flex justify-content-center align-items-center h-100"
                        >
                            <b-btn
                                v-if="!isLastItem"
                                icon
                                content="Next Media"
                                v-tippy
                                data-cy="next-media"
                                class="navigation-button"
                                @click="nextWalkthroughMediaItem()"
                            >
                                <font-awesome-icon :icon="['fas', 'chevron-right']"/>
                            </b-btn>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
            <div v-if="showBottomCarousel" class="d-flex justify-content-center">
                <div
                    class="d-flex flex-row justify-center mt-5 visible-carousel">
                    <div
                        ref="scrollable_div"
                        class="d-flex flex-row"
                        :class="`scrollable-div-${identifier}`"
                        style="width: 5000px;"
                    >
                        <div
                            v-for="(media, index) in media_items"
                            :key="index"
                            :id="media.node"
                        >
                            <div class="d-flex flex-column">
                                <template v-if="media.question && media.question.type === 'text_block'">
                                    <div
                                        class="child-node d-flex justify-content-center align-items-center"
                                        :class="{'selected-border': media_modal === index}"
                                        @click="selectMedia(media, index)"
                                    >
                                        <div class="d-flex justify-content-center align-items-center">
                                            <font-awesome-icon
                                                class="audio"
                                                :icon="['fad', 'file-alt']"
                                            />
                                        </div>
                                    </div>
                                </template>
                                <template v-else-if="media.question &&
                                    media.question.type === 'media_block' &&
                                    media.question.content.media"
                                >
                                    <div v-if="media.question.content.media.type !== 'audio' &&
                                        media.question.content.media.type !== 'video'"
                                         class="child-node background-image"
                                         :class="{'selected-border': media_modal === index}"
                                         :style="{'background-image': `url('${media.question.content.media.src}')`}"
                                         @click="selectMedia(media, index)"
                                    >
                                    </div>
                                    <div v-else
                                         class="child-node d-flex justify-content-center align-items-center"
                                         :class="{'selected-border': media_modal === index}"
                                         @click="selectMedia(media, index)"
                                    >
                                        <div class="d-flex justify-content-center align-items-center">
                                            <font-awesome-icon
                                                class="audio"
                                                :icon="[
                                                    'fad',
                                                    media.question.content.media.type === 'audio' ?
                                                     'file-audio' : 'video'
                                                ]"
                                            />
                                        </div>
                                    </div>
                                </template>
                                <template v-else-if="media.related_media_id">
                                    <div v-if="media.type !== 'audio' && media.type !== 'video'"
                                         class="child-node background-image"
                                         :class="{'selected-border': media_modal === index}"
                                         :style="{'background-image': `url('${media.url}')`}"
                                         @click="selectMedia(media, index)"
                                    >
                                    </div>
                                    <div
                                        v-else
                                        class="child-node d-flex justify-content-center align-items-center"
                                        :class="{'selected-border': media_modal === index}"
                                        @click="selectMedia(media, index)"
                                    >
                                        <div class="d-flex justify-content-center align-items-center">
                                            <font-awesome-icon
                                                class="audio"
                                                :class="{
                                                    'position-icon-audio': !media.reviewed,
                                                    'position-icon-audio-with-reviewed': media.reviewed
                                                }"
                                                :icon="['fad', media.type === 'audio' ? 'file-audio' : 'video']"
                                            />
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div
                                        class="child-node d-flex justify-content-center align-items-center"
                                        :class="{'selected-border': media_modal === index}"
                                        :style="{
                                            'background-image': `url('${media.splash_url}')`,
                                            'background-size': 'contain',
                                        }"
                                        @click="selectMedia(media, index)"
                                    ></div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data: () => ({
        media_modal: 0,
        xValue: 0,
        widthPerBlock: 130,
        numberOfItemsToMoveBy: 1,
        media_items: [],
        differenceInSelectedAndCurrent: 0,
        direction: 'right'
    }),
    props: {
        identifier: {
            type: String,
            default: ''
        },
        walkthroughMedia: {
            type: Array,
            default: () => []
        },
        showBottomCarousel: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        media_item: function (newMediaItem, oldMediaItem) {
            // this fixes a bug if there are two videos or audio clips one after the other in the walkthrough not loading the new media
            if (newMediaItem && newMediaItem.url) {
                const videoAudioElement = this.$refs.videoAudioElement;

                if (videoAudioElement) {
                    videoAudioElement.src = newMediaItem.url;
                    videoAudioElement.load();
                }
            } else if (newMediaItem && newMediaItem.question && newMediaItem.question.type === 'media_block' && newMediaItem.question.content.media.src) {
                const videoAudioElement = this.$refs.videoAudioElement;

                if (videoAudioElement) {
                    videoAudioElement.src = newMediaItem.question.content.media.src;
                    videoAudioElement.load();
                }
            }
        }
    },
    computed: {
        are_media_items_more_than_seven() {
            return this.walkthroughMedia.length > 7
        },
        media_item() {
            if (this.media_items[this.media_modal]) {
                return this.media_items[this.media_modal]
            } else {
                return null
            }
        },
        isFirstItem() {
            return this.media_modal === 0
        },
        isLastItem() {
            return this.media_modal === this.media_items.length - 1
        },
        isLastSegment() {
            if (this.media_modal >= this.media_items.length - 4 && this.media_modal <= this.media_items.length - 1) {
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        text_block_body(question) {
            var body = question.content.question;
            body = question.content.question ? body.replaceAll('merlin-img', 'img') : ''
            body = question.content.question ? body.replaceAll('sbp-img', 'img') : ''
            return body
        },

        prevWalkthroughMediaItem() {
            this.media_modal--
            if (this.are_media_items_more_than_seven) {
                let div = document.querySelector(`.scrollable-div-${this.identifier}`)
                this.numberOfItemsToMoveBy = this.differenceInSelectedAndCurrent === 0 ? 1 : this.differenceInSelectedAndCurrent + 1
                this.xValue = this.xValue + (this.widthPerBlock * this.numberOfItemsToMoveBy)
                this.xValue = this.xValue > 0 ? 0 : this.xValue
                if (div) {
                    div.style.transform = `translateX(${this.xValue}px)`
                    div.style.transition = 'transform 0.5s linear'
                }
            }
            if (this.$refs && this.$refs.main_carousel_div) {
                if (this.media_items && this.media_items.length && this.media_items[this.media_modal] && this.media_items[this.media_modal].media_type === 'document') {
                    this.$refs.main_carousel_div.style.width = '800px'
                } else {
                    this.$refs.main_carousel_div.style.width = 'auto'
                }
            }
        },
        nextWalkthroughMediaItem() {
            this.media_modal++
            if (this.are_media_items_more_than_seven) {
                let div = document.querySelector(`.scrollable-div-${this.identifier}`)
                this.numberOfItemsToMoveBy = this.differenceInSelectedAndCurrent === 0 ? 1 : this.differenceInSelectedAndCurrent + 1
                this.xValue = this.xValue - (this.widthPerBlock * this.numberOfItemsToMoveBy)
                let xValueLimit = this.widthPerBlock * (this.media_items.length - 7) * -1
                this.xValue = this.xValue < xValueLimit ? xValueLimit : this.xValue
                if (div) {
                    div.style.transform = `translateX(${this.xValue}px)`
                    div.style.transition = 'transform 0.5s linear'
                }
            }
            if (this.$refs && this.$refs.main_carousel_div) {
                if (this.media_items && this.media_items.length && this.media_items[this.media_modal] && this.media_items[this.media_modal].media_type === 'document') {
                    this.$refs.main_carousel_div.style.width = '800px'
                } else {
                    this.$refs.main_carousel_div.style.width = 'auto'
                }
            }
        },
        selectMedia(media, index) {

            if (this.media_modal > index) {
                this.direction = 'left'
                this.differenceInSelectedAndCurrent = this.media_modal - index
            } else {
                this.direction = 'right'
                this.differenceInSelectedAndCurrent = index - this.media_modal
            }
            this.media_modal = index
            if (this.are_media_items_more_than_seven && !this.isLastSegment && this.direction === 'right') {
                let div = document.querySelector(`.scrollable-div-${this.identifier}`)
                this.numberOfItemsToMoveBy = this.differenceInSelectedAndCurrent === 0 ? 1 : this.differenceInSelectedAndCurrent
                this.xValue = this.xValue - (this.widthPerBlock * this.numberOfItemsToMoveBy)
                this.differenceInSelectedAndCurrent = 0
                if (div) {
                    div.style.transform = `translateX(${this.xValue}px)`
                    div.style.transition = 'transform 0.5s linear'
                }
            }
            this.differenceInSelectedAndCurrent = 0
            if (this.$refs && this.$refs.main_carousel_div) {
                if (this.media_items && this.media_items.length && this.media_items[this.media_modal] && this.media_items[this.media_modal].media_type === 'document') {
                    this.$refs.main_carousel_div.style.width = '800px'
                } else {
                    this.$refs.main_carousel_div.style.width = 'auto'
                }
            }
        }
    },
    mounted() {
        this.media_modal = 0
        this.media_items = this.walkthroughMedia.map((media, index) => {
            let media_type = ''
            const relatedMedia = media.related_media
            if (relatedMedia) {
                if (relatedMedia.url.includes('.pdf') || relatedMedia.type === 'pdf' || relatedMedia.type === 'document') {
                    media_type = 'document'
                }
            }
            // prevent relatedMedia's thumbnail from overwriting a slides
            if (relatedMedia && relatedMedia.splash_url !== undefined) {
                delete relatedMedia.splash_url
            }

            return {
                ...media,
                ...relatedMedia,
                index,
                node: `node${index + 1}`,
                media_type
            }
        })

        this.media_items = this.media_items.map((media, index) => {
            return {
                ...media,
                index,
            }
        })

        if (this.$refs && this.$refs.main_carousel_div) {
            if (this.media_items && this.media_items.length && this.media_items[this.media_modal] && this.media_items[this.media_modal].media_type === 'document') {
                this.$refs.main_carousel_div.style.width = '800px'
            } else {
                this.$refs.main_carousel_div.style.width = 'auto'
            }
        }

    }
}
</script>
<style lang="scss" scoped>

@font-face {
    font-family: muli-regular;
    src: url(~@/assets/Muli-Light.ttf);
}

.carousel-container {
    font-family: "muli-regular";
    font-size: 24px;
    line-height: 32px;
    margin-top: 5px;
}

.walkthrough-video {
    height: 90%;
}

.card-body img {
    max-height: 100%;
    width: auto;
}

.reduced-width {
    width: 80% !important;
}

.navigation-button {
    width: 40px;
    height: 40px;
    background-color: #919191 !important;
    color: #ffffff !important;
    border-radius: 100px;
    border: none;
    justify-content: center;
    align-items: center;
    transition: .2s ease;
}

.navigation-button:hover {
    opacity: .9;
}

.background-image {
    background-size: contain !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
    background-color: black !important;
}

.main-carousel-div {
    height: 400px !important;
}

.selected-border {
    border: solid 3px #2c7cf6;
}

.child-node {
    width: 120px;
    height: 50px;
    border-radius: 5px;
    margin: 5px;
    cursor: pointer;
    background: #e9eef3;
}

.audio {
    font-size: x-large;
    color: #0070b9;
}

.full-height {
    height: 100%;
}

.visible-carousel {
    width: 910px;
    overflow-x: hidden;
}

.position-icon-audio {
    margin-top: 0px;
}

.position-icon-text {
    margin-top: 0px;
}

.position-icon-video {
    margin-top: 9px;
}

.position-icon-audio-with-reviewed {
    margin-left: 50px;
    margin-top: 0px;
}

.position-icon-text-with-reviewed {
    margin-left: 50px;
    margin-top: 3px;
}

.position-icon-text-with-reviewed-more-than-seven {
    margin-left: 50px;
    margin-top: 0px;
}

.position-icon-video-with-reviewed {
    margin-left: 40px;
    margin-top: 0px;
}


@mixin check-circle-icon-style {
    font-size: xx-large;
    color: #009900;
    background: #ffffff;
    border-radius: 100px;
}

.check-circle-icon-less-than-seven-background-image {
    margin-left: 84px;
    @include check-circle-icon-style;
}

.check-circle-icon-more-than-seven-background-image {
    margin-left: 83px;
    margin-top: -3px;
    @include check-circle-icon-style;
}

.check-circle-icon-more-than-seven-background-image-without-border {
    margin-left: 86px;
    margin-top: 0px;
    @include check-circle-icon-style;
}

.check-circle-icon-less-than-seven {
    margin-left: 15px;
    @include check-circle-icon-style;
}

.check-circle-icon-more-than-seven {
    margin-left: 15px;
    margin-top: -3px;
    @include check-circle-icon-style;
}

.check-circle-icon-less-than-seven-without-border {
    margin-left: 15px;
    @include check-circle-icon-style;
}

.check-circle-icon-more-than-seven-without-border {
    margin-left: 15px;
    @include check-circle-icon-style;
}

.pdf-preview {
    object-fit: contain;
}
</style>
